/**
 * An error message to show when the user attempts to access something
 * that doesn't exist.
 */
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import Link from "@khanacademy/wonder-blocks-link";
import {actionStyles} from "@khanacademy/wonder-blocks-styles";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {
    Caption,
    HeadingMedium,
    Title,
} from "@khanacademy/wonder-blocks-typography";

import EntrypointReloadCheck from "../internal/entrypoint-reload-check.tsx";
import NotFoundBackground from "../internal/not-found-background.tsx";

export default function NotFound() {
    return (
        <EntrypointReloadCheck>
            <NotFoundBackground>
                <Title>{t`Oops!`}</Title>
                <Strut size={spacing.medium_16} />
                <HeadingMedium tag="div">
                    {t`Sorry, the page you were trying to load doesn't exist.`}
                </HeadingMedium>
                <Strut size={spacing.xLarge_32} />
                <Button href="/" style={actionStyles.inverse} kind="secondary">
                    {t`Go to Khan Academy homepage`}
                </Button>
                <Strut size={spacing.large_24} />
                <Caption style={styles.reportText}>
                    <Trans>
                        If this problem continues and you think something is
                        wrong, please{" "}
                        <Link
                            href="/reportissue?type=Defect"
                            inline={true}
                            style={actionStyles.inverse}
                        >
                            {t`send us a report`}
                        </Link>{" "}
                        and we'll look into it.
                    </Trans>
                </Caption>
            </NotFoundBackground>
        </EntrypointReloadCheck>
    );
}

const styles = StyleSheet.create({
    reportText: {
        color: semanticColor.core.foreground.knockout.default,
    },
});
